import { Dispatch } from "@reduxjs/toolkit";
import { TabType } from "../helpers/types";
import { apiDelete, apiGet, apiPost, apiPut } from "./generic.api";

export type CreateTabBody = {
  sidebarItemID: number;
  position: number;
  name: string;
};

export const getTabsForSidebarItem = async (
  dispatch: Dispatch,
  sidebarItemID: number,
): Promise<TabType[]> => {
  return (
    (
      await apiGet<{ tabs: TabType[] }>(
        dispatch,
        `api/tab?sidebarItemID=${sidebarItemID}`,
      )
    )?.tabs || []
  );
};

export const changeTabsPositions = async (
  dispatch: Dispatch,
  tabs: TabType[],
): Promise<TabType[]> => {
  return (
    (await apiPost<{ data: any }, TabType[]>(dispatch, `api/tab`, tabs))
      ?.data || []
  );
};

export const deleteTab = async (
  dispatch: Dispatch,
  tabID: number,
): Promise<TabType[]> => {
  return (
    (await apiDelete<{ data: any }, number>(dispatch, `api/tab?tabID=${tabID}`))
      ?.data || []
  );
};

export const createNewTab = async (
  dispatch: Dispatch,
  body: CreateTabBody,
): Promise<TabType[]> => {
  return (
    (await apiPut<{ updatedTabs: TabType[] }, CreateTabBody>(
      dispatch,
      `api/tab`,
      body,
    )) || []
  ).updatedTabs;
};

export const updateTab = async (
  dispatch: Dispatch,
  tabID: number,
  name: string,
  value: string,
): Promise<TabType[]> => {
  const data = { tabID, name, value };
  return (
    (
      await apiPost<
        { data: any },
        { tabID: number; name: string; value: string }
      >(dispatch, `api/tab/update`, data)
    )?.data || []
  );
};
